import { render, staticRenderFns } from "./SkuRouter.vue?vue&type=template&id=d119b14a&"
import script from "./SkuRouter.vue?vue&type=script&lang=js&"
export * from "./SkuRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports